import { getSelectedTableView } from "owa-mail-list-store";
import { resetFocus } from "owa-mail-focus-manager";
import type { ActionSource } from "owa-mail-store";
import { lazyBlockLastSendersFromTable } from "owa-mail-triage-action";
import getEffectiveRowKeys from "owa-mail-list-store/lib/utils/getEffectiveRowKeys";

export default function onBlock(actionSource: ActionSource, onBlockCompleted?: (blockAttempted: boolean) => void): void {
    const tableView = getSelectedTableView(true /*shouldGetEffectiveView*/);
    const rowKeys = getEffectiveRowKeys(tableView);
    
    lazyBlockLastSendersFromTable.importAndExecute(rowKeys, tableView, actionSource, onBlockCompleted);
    resetFocus("blockCommand");
}
